import api from './api.js';

/**
 * Subscription service
 */
class Subscription {

  /**
     * Constructor
     */
  constructor() {

    // Set URLs
    this.url = '/account/subscription';
    this.url_resume = '/account/subscription/resume';
    this.url_swap = '/account/subscription/swap';
  }

  /**
     * Create subscription for current user
     * @param {*} data 
     * @return {Promise}
     */
  create(data) {
    return api.post(this.url, data);
  }

  /**
     * Udpdate payment method
     * @param {*} data 
     * @return {Promise}
     */
  update(data) {
    return api.put(this.url, data);
  }

  /**
     * Cancel a sub
     * @return {Promise}
     */
  cancel() {
    return api.delete(this.url);
  }

  /**
     * Resume a cancelled sub if still before ends_at period
     * @return {Promise}
     */
  resume() {
    return api.post(this.url_resume);
  }

  /**
     * Swap subscription
     * @param {*} param0 
     */
  swap({params = {}}) {
    return api.post(this.url_swap, params);
  }
}

export default new Subscription;
